import React from 'react';
import LoginForm from '../../components/login/LoginForm';
import LandingProductsDisplay from '../../views/landingProductsDisplay/LandingProductsDisplay';
import { AuthHandler } from '../../contexts/Authentication';
import { CallbackFromVelocityHub } from '../../contexts/CallbackFromVelocityHub';
import LoginPageLayout from '../../layouts/loginLayout/LoginPageLayout';
import AutocountLayout from '../../layouts/autocountLayout/AutocountLayout';
import Profile from '../../views/profile/Profile';

const LAYOUT = '/';

const routes = {
  callback: {
    component: CallbackFromVelocityHub,
    path: '/implicit/callback',
    isSecured: false,
  },  
  authHandler: {
    component: AuthHandler,
    path: LAYOUT,
    isSecured: false,
  },
  login: {
    component: LoginPageLayout,
    path: '/login',
    children: <LoginForm />,
    isSecured: false,
  },
  welcome: {
    component: LandingProductsDisplay,
    path: '/welcome',
  },
  autocount: {
    component: AutocountLayout,
    path: '/autocount',
    exact: false,
  },
  profile: {
    component: Profile,
    path: '/profile',
  },
};

export { routes, LAYOUT };
